import { mapStagesToInterviewPlanItems } from "client/utils/migration-transition";
import { StageStatus } from "generated/schemaTypes";
import { useMemo } from "react";

import {
  InterviewPlanView,
  InterviewPlanViewProps,
} from "../interview-plan/InterviewPlanView";

type TransitionInterviewPlanViewProps = Omit<
  InterviewPlanViewProps,
  "interviewPlan" | "currentInterviewPlanItemId"
> & {
  stages: {
    id: string;
    status?: StageStatus;
    position: number;
    title: string;
    description: string | null;
  }[];
};

export function TransitionInterviewPlanView({
  stages,
  ...props
}: TransitionInterviewPlanViewProps) {
  const currentStage = useMemo(
    () => stages.find((stage) => stage.status === StageStatus.CURRENT),
    [stages]
  );

  return (
    <InterviewPlanView
      {...props}
      interviewPlan={{
        items: mapStagesToInterviewPlanItems({ stages }),
      }}
      currentInterviewPlanItemId={currentStage?.id}
    />
  );
}
